import { render, staticRenderFns } from "./etiquetas.vue?vue&type=template&id=4a58e2b1&"
import script from "./etiquetas.vue?vue&type=script&lang=js&"
export * from "./etiquetas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports